import { useQuery } from '@tanstack/react-query';
import { getWelcomeBonus } from './api';

const FIVE_MINUTES = 5 * 60 * 1000;

export interface WelcomeBonus {
  amountSom: number;
  /** ISO instant the offer ends; null = no end. */
  endsAt: string | null;
}

/**
 * The live welcome bonus, or null when admins switched it off, set it to 0, or it ended.
 * Null also while loading or on error, so no bonus is ever promised that the API would not pay.
 */
export function useWelcomeBonus(): WelcomeBonus | null {
  const { data } = useQuery({
    queryKey: ['welcome-bonus'],
    queryFn: ({ signal }) => getWelcomeBonus(signal),
    staleTime: FIVE_MINUTES,
    retry: false,
  });
  if (!data || !(data.balanceSom > 0)) return null;
  // A page left open past the deadline stops offering it without waiting for a refetch.
  if (data.endsAt && Date.parse(data.endsAt) <= Date.now()) return null;
  return { amountSom: data.balanceSom, endsAt: data.endsAt ?? null };
}
